import React from "react";
export default function Card({ children }) {
  return <div className="bg-white box-border p-5">{children}</div>;
}
